import request from '@apps-common/js-client/api/request';
import {DATA_API_BASE_URL} from '@account/config';
import {useQuery} from '@tanstack/react-query';

const getItemTypes = () =>
  request
    .get(`${DATA_API_BASE_URL}/item-types`)
    .then(res => res.data.item_types);

export const useGetItemTypes = () =>
  useQuery({
    queryKey: ['itemTypes'],
    queryFn: () => getItemTypes(),
  });
